/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import React from 'react';
import { useSelector } from 'react-redux';
import PageHeader from '../../component/Common/PageHeader/PageHeader';
import { ButtonContainer } from '../Users/Users.style';
import ButtonComp from '../../component/Common/Button/Button.view';
import PaginationWithPage from '../../component/Common/Pagination/PaginationWithPage.view';

const EquipmentHeader = (props) => {
  const {
    title,
    hasBack,
    isFormEditable,
    isCreate,
    handleEquipmentEdit,
    handleEquipmentCreate,
    handleSave,
    handleCancel,
    handleBack,
    children,
    pageSize = 10,
    equipmentsCount = 0,
    handlePageChange = () => {},
    isSaveEnabled,
    canAdd = 0,
    canEdit = 0
  } = props;

  const { searchQueries } = useSelector((state) => state.equipmentDetails);

  return (
    <>
      <PageHeader hasBack={hasBack} handleBack={handleBack} title={title}>
        {!isFormEditable ? (
          <ButtonContainer>
            {isCreate
              ? canAdd && (
                  <ButtonComp onClick={handleEquipmentCreate}>
                    Add Equipment
                  </ButtonComp>
                )
              : canEdit && (
                  <ButtonComp onClick={handleEquipmentEdit}>Edit</ButtonComp>
                )}
            <PaginationWithPage
              ItemsPerPage={pageSize}
              total={equipmentsCount}
              handlePageChange={handlePageChange}
              searchParams={searchQueries}
            />
          </ButtonContainer>
        ) : (
          <ButtonContainer>
            <ButtonComp onClick={handleCancel}>Cancel</ButtonComp>
            <ButtonComp disabled={!isSaveEnabled} dark onClick={handleSave}>
              Save
            </ButtonComp>
          </ButtonContainer>
        )}
        {children}
      </PageHeader>
    </>
  );
};

export default EquipmentHeader;
